shadow$provide[287] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Subdivide:{enumerable:true, get:function() {
  return Subdivide;
}}});
var UGLSL = require("../../../util/glsl.js");
var require$_DOT__SLASH_operator_DOT_js = require("./operator.js");
class Subdivide extends require$_DOT__SLASH_operator_DOT_js.Operator {
  static initClass() {
    this.traits = ["node", "bind", "operator", "source", "index", "subdivide"];
  }
  indexShader(shader) {
    shader.pipe(this.indexer);
    return super.indexShader(shader);
  }
  sourceShader(shader) {
    return shader.pipe(this.operator);
  }
  getDimensions() {
    return this._resample(this.bind.source.getDimensions());
  }
  getActiveDimensions() {
    return this._resample(this.bind.source.getActiveDimensions());
  }
  getFutureDimensions() {
    return this._resample(this.bind.source.getFutureDimensions());
  }
  getIndexDimensions() {
    return this._resample(this.bind.source.getIndexDimensions());
  }
  _resample(dims) {
    const r = this.resampled;
    dims.items--;
    dims.width--;
    dims.height--;
    dims.depth--;
    if (r.items != null) {
      dims.items *= r.items;
    }
    if (r.width != null) {
      dims.width *= r.width;
    }
    if (r.height != null) {
      dims.height *= r.height;
    }
    if (r.depth != null) {
      dims.depth *= r.depth;
    }
    dims.items++;
    dims.width++;
    dims.height++;
    dims.depth++;
    return dims;
  }
  make() {
    super.make();
    if (this.bind.source == null) {
      return;
    }
    let {lerp} = this.props;
    const {items, width, height, depth} = this.props;
    this.resampled = {};
    if (items != null) {
      this.resampled.items = items;
    }
    if (width != null) {
      this.resampled.width = width;
    }
    if (height != null) {
      this.resampled.height = height;
    }
    if (depth != null) {
      this.resampled.depth = depth;
    }
    const operator = this._shaders.shader();
    const indexer = this._shaders.shader();
    const uniforms = {resampleFactor:this._attributes.make(this._types.vec4(0, 0, 0, 0)), subdivideBevel:this.node.attributes["subdivide.bevel"],};
    this.resampleFactor = uniforms.resampleFactor;
    this.resampleBias = uniforms.resampleBias;
    const resize = items != null || width != null || height != null || depth != null;
    if (resize) {
      operator.pipe("resample.relative", uniforms);
      indexer.pipe("resample.relative", uniforms);
    } else {
      operator.pipe(UGLSL.identity("vec4"));
      indexer.pipe(UGLSL.identity("vec4"));
    }
    let sampler = this.bind.source.sourceShader(this._shaders.shader());
    lerp = lerp ? ".lerp" : "";
    const iterable = ["width", "height", "depth", "items"];
    for (let i = 0; i < iterable.length; i++) {
      const key = iterable[i];
      const id = `subdivide.${key}${lerp}`;
      if (this.props[key] != null) {
        sampler = this._shaders.shader().require(sampler);
        sampler.pipe(id, uniforms);
      }
    }
    operator.pipe(sampler);
    this.operator = operator;
    return this.indexer = indexer;
  }
  unmake() {
    super.unmake();
    return this.operator = null;
  }
  resize() {
    if (this.bind.source == null) {
      return;
    }
    const dims = this.bind.source.getActiveDimensions();
    const target = this.getActiveDimensions();
    const axis = key => Math.max(1, dims[key] - 1) / Math.max(1, target[key] - 1);
    const rw = axis("width");
    const rh = axis("height");
    const rd = axis("depth");
    const ri = axis("items");
    this.resampleFactor.value.set(rw, rh, rd, ri);
    return super.resize();
  }
  change(changed, touched, _init) {
    if (touched["operator"] || touched["subdivide"]) {
      return this.rebuild();
    }
  }
}
Subdivide.initClass();

};